import { render } from "./KpiCardAlternative.vue?vue&type=template&id=00da593f&scoped=true"
import script from "./KpiCardAlternative.vue?vue&type=script&lang=js"
export * from "./KpiCardAlternative.vue?vue&type=script&lang=js"

import "./KpiCardAlternative.vue?vue&type=style&index=0&id=00da593f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00da593f"]])

export default __exports__